import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { api } from "./api/api";

// Firebase configuration placeholder
const firebaseConfig = {
    apiKey: "AIzaSyCuXoC0TQgwqlbHZw1E-pc3aopIIGT8oyk",
    authDomain: "test-a17f6.firebaseapp.com",
    projectId: "test-a17f6",
    storageBucket: "test-a17f6.firebasestorage.app",
    messagingSenderId: "92628886298",
    appId: "1:92628886298:web:a3442135b732daf96682a3",
    measurementId: "G-Q0JMWXCZ6T"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestForToken = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            const vapidKey = "BNGKgIo-h3DAxaX1U6mJBUMbF6iEeWmv-1uQVzBhneO_oOfAzeG5ZOgIP0EiSQYtGzUetflKHpIsXcOM3EODGrY"; // Firebase Console > Project Settings > Cloud Messaging > Web Push certificates

            if (vapidKey === "YOUR_VAPID_KEY") {
                console.warn("⚠️ VAPID Key is placeholder. Push notification subscription skipped.");
                return;
            }

            const currentToken = await getToken(messaging, {
                vapidKey: vapidKey
            });
            if (currentToken) {
                console.log("FCM Token:", currentToken);
                // Token'ı backend'e kaydet
                await api.post("/users/registerFcmToken", { fcmToken: currentToken });
            } else {
                console.log("Token alınamadı. İzin verildiğinden emin olun.");
            }
        }
    } catch (error) {
        console.error("Bildirim izni/token hatası:", error);
    }
};

export const onMessageListener = (callback) =>
    onMessage(messaging, (payload) => {
        callback(payload);
    });

export default app;
